// extracted by mini-css-extract-plugin
export default {"wrapper":"message-display_wrapper__cJXK4","message":"message-display_message__RoCtr"};